module.exports = __webpack_public_path__ + "static/media/plug_326.476175e1.png";